import { NavLink, useLocation } from 'react-router';

import { cn } from '@/shared/lib/cn';

import { PRIMARY_SECTIONS as NAV_ITEMS } from './sections';

/**
 * Нижняя панель телефона. На широком экране её место занимает боковое меню
 * (`SideNav`), поэтому от 1024 px панель скрыта.
 */
export function BottomNav() {
  const { pathname } = useLocation();

  /**
   * Указатель активного раздела едет по нижней панели сам, средствами CSS.
   *
   * Раньше это была общая анимация раскладки: красиво, но ради неё библиотека
   * анимаций попадала в первый загружаемый пакет — 41 КБ сжатого кода до кода
   * любого экрана, при том что панель рисует одну полоску. Здесь же
   * анимируется только `transform`, то есть работа уходит на композитор.
   */
  const activeIndex = NAV_ITEMS.findIndex((item) => pathname.startsWith(item.to));

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border glass pb-safe select-none lg:hidden"
      aria-label="Основная навигация"
    >
      <div className="relative mx-auto max-w-lg">
        {activeIndex >= 0 && (
          <span
            className="pointer-events-none absolute top-0 flex justify-center transition-transform duration-200 ease-out"
            style={{
              width: `${100 / NAV_ITEMS.length}%`,
              transform: `translateX(${activeIndex * 100}%)`,
            }}
            aria-hidden
          >
            <span className="h-0.5 w-9 rounded-full bg-brand" />
          </span>
        )}

        <ul className="flex items-stretch">
          {NAV_ITEMS.map((item) => (
            <li key={item.to} className="flex-1">
              <NavLink
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'relative flex h-[var(--nav-height)] flex-col items-center justify-center gap-1',
                    'transition-colors duration-200',
                    isActive ? 'text-brand' : 'text-subtle',
                  )
                }
              >
                {({ isActive }) => (
                  <>
                    <item.icon
                      size={22}
                      strokeWidth={isActive ? 2.4 : 1.9}
                      aria-hidden
                      className="transition-transform duration-200"
                      style={{ transform: isActive ? 'scale(1.05)' : undefined }}
                    />
                    <span className="text-[11px] font-medium">{item.label}</span>
                  </>
                )}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}
